import { Controller } from '@hotwired/stimulus'

/**
 * Stimulus controller that enables a button when a specific confirmation word is entered
 * Connects to data-controller="confirm-to-enable"
 */

export default class extends Controller {
  static targets = ['input', 'button']
  static values = {
    confirmationWord: { type: String, default: '' }
  }

  connect () {
    this.refresh()
  }

  /**
   * Checks if the confirmation word matches the input value
   * and enables/disables the button accordingly
   */

  refresh () {
    if (!this.hasInputTarget || !this.hasButtonTarget) {
      return
    }

    const inputValue = this.inputTarget.value.trim()
    this.buttonTarget.toggleAttribute('disabled', inputValue !== this.confirmationWordValue)
  }
}
